import { render, staticRenderFns } from "./TestEmailText.vue?vue&type=template&id=654390d6&"
import script from "./TestEmailText.vue?vue&type=script&lang=js&"
export * from "./TestEmailText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports